import { render, staticRenderFns } from "./ImportacaoLateral.vue?vue&type=template&id=0cc198d7&lang=html&"
import script from "./ImportacaoLateral.vue?vue&type=script&lang=js&"
export * from "./ImportacaoLateral.vue?vue&type=script&lang=js&"
import style0 from "./ImportacaoLateral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/importacao/ImportacaoLateral.vue
// module id = 1413
// module chunks = 28